import { StreamingStatusDTO } from 'core/streamingStatus/StreamingStatus';
import { useMemo, useState } from 'react';
import {
  getDefaultColumnDescription,
  ColumnDefinition
} from 'components/TableColumn/TableColumn';
import i18n from 'i18n';

export enum StreamingStatusListColumns {
  CRID = 'crid',
  IS_LIVE = 'isLive'
}

export type StreamingStatusListData = {
  readonly searchString: string;
  readonly filteredList: StreamingStatusDTO[];
  readonly columns: ColumnDefinition[];
  onSearch(searchString: string): void;
};

export const useStreamingStatusListModel = (
  streamingStatusList: StreamingStatusDTO[]
): StreamingStatusListData => {
  const [searchString, onSearch] = useState<string>('');

  const filteredList = useMemo(() => {
    return streamingStatusList.filter((item) =>
      item.crid?.toString().toLowerCase().includes(searchString.toLowerCase())
    );
  }, [searchString, streamingStatusList]);

  const columns = useMemo(
    () => [
      getDefaultColumnDescription(
        StreamingStatusListColumns.CRID,
        i18n.t('streamingStatusList.headers.crid')
      ),
      {
        ...getDefaultColumnDescription(
          StreamingStatusListColumns.IS_LIVE,
          i18n.t('streamingStatusList.headers.isLive')
        ),
        formatter: (value: boolean) => (value ? 'Yes' : 'No')
      }
    ],
    []
  );

  return {
    searchString,
    filteredList,
    columns,
    onSearch
  };
};
